import $ from 'jquery';
import _ from 'underscore';
import { register } from '../../core/bootstrapper';
import AddressCheckEvents from './AddressCheckEvents';
import HelpareaEvents from './HelpareaEvents';
import ArticleEvents from './ArticleEvents';
import UspEvents from './UspEvents';
import Navigation from './Navigation';
import SearchField from './SearchField';
import * as trackingInstances from '../../../home24/helpers/tracking-instances';
import * as smartBanner from '../../../home24-shared/tracking/common/smartBanner';

register(null, function() {
  var $body = $('body');

  trackingInstances.set(
    'helpareaEvents',
    new HelpareaEvents({
      el: $body
    })
  );

  trackingInstances.set(
    'addressCheckEvents',
    new AddressCheckEvents({
      el: $body
    })
  );

  $(document).ready(function() {
    smartBanner.init();

    trackingInstances.set('articleEvents', new ArticleEvents({ el: $body }));

    trackingInstances.set('uspEvents', new UspEvents({ el: $body }));

    trackingInstances.get('helpareaEvents').executeCookieCallbacks();

    _.each($('.search-block'), function(el) {
      new SearchField({ el: el });
    });

    if (typeof window.dataLayer !== 'undefined') {
      new Navigation({ el: $('body') });
    }
  });
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/tracking/common/trackingBootstrap.js
 **/